export default __webpack_public_path__ + "static/media/Debora_Ludovar_1.09eec604.jpg";